import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BatteryEmpty"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18 18H4.5C3.67192 17.9992 3.00083 17.3281 3 16.5V7.5C3.00083 6.67192 3.67192 6.00083 4.5 6H18C18.8281 6.00083 19.4992 6.67192 19.5 7.5V8.25H20.25C21.0781 8.25083 21.7492 8.92192 21.75 9.75V14.25C21.7488 15.0779 21.0779 15.7488 20.25 15.75H19.5V16.5C19.4988 17.3279 18.8279 17.9988 18 18ZM4.5 7.5V16.5H18V14.25H20.25V9.75H18V7.5H4.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BatteryEmpty.vue"]]);
